import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import http from './utils/request'
import './styles/global.scss'

Vue.use(ElementUI)
Vue.prototype.$http = http
Vue.config.productionTip = false

// 初始化主题
const t = store.getters.themeColor
const c = store.state.theme.themes[t]
document.documentElement.style.setProperty('--color', c.primary)
document.documentElement.style.setProperty('--sub-color', c.secondary)
document.body.style.background = c.bg

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')